import Client from '@/app/repository/axios-client';

const resource = '/application/applications';

export default {
  getChildLossSupportDetails(applicationId) {
    return Client.get(`${resource}/${applicationId}/child-loss-support/details`);
  },
  changeChildLossSupportAmount(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/child-loss-support/change-amount`, payload);
  }
}
